/**
 * CharCountTextArea — atlas TextArea with a hard character limit and
 * the "N characters left" counter below (turns red at 0). Built for
 * the Premium Selection Approval Notes (600 chars) but generic.
 */
import { TextArea } from "@tricura/atlas-ui";

interface CharCountTextAreaProps {
    label?: string;
    "aria-label"?: string;
    value: string;
    onChange: (value: string) => void;
    maxLength: number;
    placeholder?: string;
    rows?: number;
    isDisabled?: boolean;
    /** Custom attribute for E2E testing. */
    "data-autotest"?: string;
}

export function CharCountTextArea({
    label,
    "aria-label": ariaLabel,
    value,
    onChange,
    maxLength,
    placeholder,
    rows = 4,
    isDisabled,
    "data-autotest": dataAutotest,
}: CharCountTextAreaProps) {
    const remaining = Math.max(0, maxLength - value.length);
    return (
        <TextArea
            label={label}
            aria-label={ariaLabel}
            value={value}
            // maxLength caps the field natively; the slice guards paste
            // paths some browsers let through.
            onChange={(next) => onChange(next.slice(0, maxLength))}
            maxLength={maxLength}
            placeholder={placeholder}
            rows={rows}
            size="sm"
            isDisabled={isDisabled}
            hint={<span className={remaining === 0 ? "text-error-primary" : undefined}>{remaining} characters left</span>}
            data-autotest={dataAutotest}
        />
    );
}
